import { OfferData } from '../../steps-library/step-util/steps-helper';
import { CustomStepCategoryEnum, OfferStages, StepCategory, StepPopupActions } from '../../_models';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, FunnelService, StepTemplateService } from '../../_services';
import { CrudSavePopupComponent } from '../../_directives';
import { FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  moduleId: module.id.toString(),
  selector: 'retention-stage-popup',
  templateUrl: './retention-stage-popup.component.html',
  styleUrls: ['./../retention/retention-offers.component.scss'],
})
export class RetentionStagePopupComponent extends CrudSavePopupComponent implements OnInit {
  ngModelOptions = { standalone: true };
  StepPopupActions = StepPopupActions;
  public surveyOptions: { value: string; label: string }[] = [];
  public surveyCategories: StepCategory[] = [
    CustomStepCategoryEnum.Survey,
    CustomStepCategoryEnum.CancelOrderSurvey,
    CustomStepCategoryEnum.CancelTrialSurvey,
    CustomStepCategoryEnum.CancelSubSurvey,
    CustomStepCategoryEnum.ReturnSurvey,
    CustomStepCategoryEnum.PauseSurvey,
  ];

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected formBuilder: FormBuilder,
    protected funnelService: FunnelService,
    protected alertService: AlertService,
    protected stepTemplateService: StepTemplateService
  ) {
    super(router, location, route, funnelService, alertService);
    this.isNew = false;
    this.isPartial = true;
  }

  ngOnInit() {
    this.setForm(
      this.formBuilder.group({
        offer_intent: [null, Validators.required],
      })
    );

    super.ngOnInit();
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid || this.inputData.popupType === StepPopupActions.Delete) {
      this.loading = true;
      const { popupType, offer_id, ...formData } = this.getFormData();

      if (popupType === StepPopupActions.Create) {
        this.funnelService.createStage(formData).subscribe(
          (data) => {
            if (this.showSuccessMessage) {
              this.alertService.success('Stage Created Successfully.', true);
            }

            this.canDeactivateService.setFormDirty(false);
            this.onSaveComplete(data);
          },
          (error) => {
            this.handleSubmitError(error);
            this.loading = false;
          }
        );
      } else {
        let operation: Observable<Object>;

        if (popupType === StepPopupActions.Update) {
          operation = this.funnelService.update(offer_id, formData);
        } else if (popupType === StepPopupActions.Duplicate) {
          operation = this.funnelService.clone(offer_id);
        } else if (popupType === StepPopupActions.Delete) {
          operation = this.funnelService.delete(offer_id);
        }

        const operationTitle =
          popupType === StepPopupActions.Update
            ? 'Updated'
            : popupType === StepPopupActions.Duplicate
            ? 'Duplicated'
            : popupType === StepPopupActions.Delete
            ? 'Deleted'
            : '';

        operation.subscribe(
          (data) => {
            if (this.showSuccessMessage) {
              this.alertService.success(`${'Stage'} ${operationTitle} Successfully.`, true);
            }

            this.canDeactivateService.setFormDirty(false);
            this.onSaveComplete(data);
          },
          (error) => {
            this.handleSubmitError(error);
            this.loading = false;
          }
        );
      }
    }
  }

  protected getFormData() {
    const data = {
      ...OfferData,
      ...this.form.value,
      name: OfferStages[this.form.value.offer_intent],
      offer_id: this.inputData.offer_id,
      offer_type: this.inputData.offer_type,
      offer_intent: this.form.value.offer_intent,
      popupType: this.inputData.popupType,
    };
    return data;
  }

  popupTypeTextMap: Partial<Record<StepPopupActions, string>> = {
    [StepPopupActions.Delete]: 'Delete',
    [StepPopupActions.Create]: 'Done',
  };
}
